
const isWalkable = value => value !== null && typeof value !== 'undefined'
const getChild = (parent, child) => (isWalkable(parent) ? parent[child] : undefined)
export default (descendants, origin) => descendants.split('.').reduce(getChild, origin)



// WEBPACK FOOTER //
// ./node_modules/nespresso-library/src/utils/getIn.js